import { render, staticRenderFns } from "./RingGroups.vue?vue&type=template&id=9cb68896&scoped=true&"
import script from "./RingGroups.vue?vue&type=script&lang=js&"
export * from "./RingGroups.vue?vue&type=script&lang=js&"
import style0 from "./RingGroups.vue?vue&type=style&index=0&id=9cb68896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb68896",
  null
  
)

export default component.exports